import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyH2 } from '~/core/ui/Heading'
import LPContainer from './LPContainer'
import { cn } from '~/core/ui/utils'
import { TypographyText } from '~/core/ui/Text'

const ApplicantTrackingCRMIntegratedSaveTimeSection: FCC<{
  className?: string
}> = ({ className }) => {
  const { t } = useTranslation()
  const [switchTabs, setSwitchTabs] = useState('option-1')

  return (
    <div
      className={`overflow-hidden my-[100px] tablet:my-[164px] ${className}`}>
      <LPContainer>
        <div className="flex-1 flex flex-col justify-center max-w-3xl mx-auto items-center text-center">
          <TypographyH2 className="mt-3 mb-4 text-center text-4xl tablet:text-4.5xl font-normal">
            {t('applicant_tracking_crm:integrated:title')}
          </TypographyH2>
          <div
            className="text-[19px] lead-[28px]"
            dangerouslySetInnerHTML={{
              __html: `${t('applicant_tracking_crm:integrated:description')}`
            }}
          />
        </div>

        <div className="mt-[46px]">
          <div className="flex px-3 mx-auto max-w-[669px] py-2 space-x-[24px] border border-[#EDF0F4] rounded-[36px] overflow-x-auto tablet:overflow-x-hidden">
            <div
              onClick={() => setSwitchTabs('option-1')}
              className={cn(
                'rounded-[36px] py-2.5 px-4 cursor-pointer whitespace-nowrap flex-1 hover:bg-[#272A35] hover:text-white',
                switchTabs === 'option-1'
                  ? 'bg-[#272A35] text-white'
                  : 'bg-white text-gray-900'
              )}>
              <TypographyText className="text-center">
                {t('applicant_tracking_crm:integrated:integrated01')}
              </TypographyText>
            </div>
            <div
              onClick={() => setSwitchTabs('option-2')}
              className={cn(
                'rounded-[36px] py-2.5 px-4 cursor-pointer whitespace-nowrap flex-1 hover:bg-[#272A35] hover:text-white',
                switchTabs === 'option-2'
                  ? 'bg-[#272A35] text-white'
                  : 'bg-white text-gray-900'
              )}>
              <TypographyText className="text-center">
                {t('applicant_tracking_crm:integrated:integrated02')}
              </TypographyText>
            </div>
            <div
              onClick={() => setSwitchTabs('option-3')}
              className={cn(
                'rounded-[36px] py-2.5 px-4 cursor-pointer whitespace-nowrap flex-1 hover:bg-[#272A35] hover:text-white',
                switchTabs === 'option-3'
                  ? 'bg-[#272A35] text-white'
                  : 'bg-white text-gray-900'
              )}>
              <TypographyText className="text-center">
                {t('applicant_tracking_crm:integrated:integrated03')}
              </TypographyText>
            </div>
            <div
              onClick={() => setSwitchTabs('option-4')}
              className={cn(
                'rounded-[36px] py-2.5 px-4 cursor-pointer whitespace-nowrap flex-1 hover:bg-[#272A35] hover:text-white',
                switchTabs === 'option-4'
                  ? 'bg-[#272A35] text-white'
                  : 'bg-white text-gray-900'
              )}>
              <TypographyText className="text-center">
                {t('applicant_tracking_crm:integrated:integrated04')}
              </TypographyText>
            </div>
          </div>

          <div className="mt-[50px] bg-[#F6F9FE] relative">
            <div className={switchTabs === 'option-1' ? '' : 'hidden'}>
              <div className="tablet:max-w-[220px] tablet:absolute tablet:top-[127px] tablet:left-[68px] pt-[36px] tablet:pt-0 pl-[30px] tablet:pl-0 animate-[slideInFromLeft_0.15s_linear_0.25s_both]">
                <TypographyText className="text-2xl tablet:text-3xl font-medium text-gray-900">
                  {t('applicant_tracking_crm:integrated:integrated01_title')}
                </TypographyText>
                <TypographyText className="text-base tablet:text-lg font-normal text-gray-900 mt-[14px]">
                  {t(
                    'applicant_tracking_crm:integrated:integrated01_description'
                  )}
                </TypographyText>
              </div>
              <img
                src={'/img/feature/applicant-tracking-crm/integrated-01.png'}
                alt="integrated-01"
                className="h-auto w-full hidden tablet:block"
              />
              <img
                src={
                  '/img/feature/applicant-tracking-crm/integrated-01-mobile.png'
                }
                alt="integrated-01"
                className="h-auto w-full tablet:hidden"
              />
            </div>
            <div className={switchTabs === 'option-2' ? '' : 'hidden'}>
              <div className="tablet:max-w-[220px] tablet:absolute tablet:top-[127px] tablet:left-[68px] pt-[36px] tablet:pt-0 pl-[30px] tablet:pl-0 animate-[slideInFromLeft_0.15s_linear_0.25s_both]">
                <TypographyText className="text-2xl tablet:text-3xl font-medium text-gray-900">
                  {t('applicant_tracking_crm:integrated:integrated02_title')}
                </TypographyText>
                <TypographyText className="text-base tablet:text-lg font-normal text-gray-900 mt-[14px]">
                  {t(
                    'applicant_tracking_crm:integrated:integrated02_description'
                  )}
                </TypographyText>
              </div>
              <img
                src={'/img/feature/applicant-tracking-crm/integrated-02.png'}
                alt="integrated-02"
                className="h-auto w-full hidden tablet:block"
              />
              <img
                src={
                  '/img/feature/applicant-tracking-crm/integrated-02-mobile.png'
                }
                alt="integrated-02"
                className="h-auto w-full tablet:hidden"
              />
            </div>

            <div className={switchTabs === 'option-3' ? '' : 'hidden'}>
              <div className="tablet:max-w-[220px] tablet:absolute tablet:top-[127px] tablet:left-[68px] pt-[36px] tablet:pt-0 pl-[30px] tablet:pl-0 animate-[slideInFromLeft_0.15s_linear_0.25s_both]">
                <TypographyText className="text-2xl tablet:text-3xl font-medium text-gray-900">
                  {t('applicant_tracking_crm:integrated:integrated03_title')}
                </TypographyText>
                <TypographyText className="text-base tablet:text-lg font-normal text-gray-900 mt-[14px]">
                  {t(
                    'applicant_tracking_crm:integrated:integrated03_description'
                  )}
                </TypographyText>
              </div>
              <img
                src={'/img/feature/applicant-tracking-crm/integrated-03.png'}
                alt="integrated-03"
                className="h-auto w-full hidden tablet:block"
              />
              <img
                src={
                  '/img/feature/applicant-tracking-crm/integrated-03-mobile.png'
                }
                alt="integrated-03"
                className="h-auto w-full tablet:hidden"
              />
            </div>
            <div className={switchTabs === 'option-4' ? '' : 'hidden'}>
              <div className="tablet:max-w-[220px] tablet:absolute tablet:top-[127px] tablet:left-[68px] pt-[36px] tablet:pt-0 pl-[30px] tablet:pl-0 animate-[slideInFromLeft_0.15s_linear_0.25s_both]">
                <TypographyText className="text-2xl tablet:text-3xl font-medium text-gray-900">
                  {t('applicant_tracking_crm:integrated:integrated04_title')}
                </TypographyText>
                <TypographyText className="text-base tablet:text-lg font-normal text-gray-900 mt-[14px]">
                  {t(
                    'applicant_tracking_crm:integrated:integrated04_description'
                  )}
                </TypographyText>
              </div>
              <img
                src={'/img/feature/applicant-tracking-crm/integrated-04.png'}
                alt="integrated-04"
                className="h-auto w-full hidden tablet:block"
              />
              <img
                src={'/img/feature/applicant-tracking-crm/integrated-04.png'}
                alt="integrated-04"
                className="h-auto w-full tablet:hidden"
              />
            </div>
          </div>
        </div>
      </LPContainer>
    </div>
  )
}

export default ApplicantTrackingCRMIntegratedSaveTimeSection
